<template>
  <div class="shouye-center-d">
    <div class="sy-d-top">
        <h4>Cooperative Partner</h4>
        <div class="sy-d-top-cen">
            <span>战略合作伙伴</span>
        </div>
    </div>
    <div class="sy-d-center">
        <ul v-if="cooperativePartner">
            <li v-for="(item,i) in realPartner" :key="i">
                <div class="sy-d-center-img">
                    <img :src="item" />
                </div>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
  name: "D",
  data() {
    return {
       cooperativePartner: this.$store.state.cooperativePartner
    };
  },
  watch:{
    '$store.state.cooperativePartner'(val){
        this.cooperativePartner = val
    }
  },
  computed:{
    realPartner(){
      return this.cooperativePartner ? this.cooperativePartner.slice(0,24) : []
    }
  }
}
</script>
